import React from 'react';
import './HubLogoMark.css';

// The "Hub by HConnect" brand mark.
//
// Extracted because the same 4-rect SVG had been hand-copied into Navbar and LandingPage with their own
// near-identical CSS, so a brand change meant hunting for every copy - and the sync pipeline strip would
// have been a third. One component, one definition.
//
// Everything scales off `size` (the source art is an 18px glyph on a 32px tile, hence the ratios) so it
// can sit in a 32px sidebar header or a 28px pipeline card without a second set of rules.
const HubLogoMark = ({ size = 32, title }) => (
  <div
    className="hub-logo-mark"
    style={{ width: size, height: size, borderRadius: Math.round(size * 0.25) }}
    title={title}
  >
    <svg width={size * (18 / 32)} height={size * (18 / 32)} viewBox="0 0 18 18" fill="none" aria-hidden="true">
      <rect x="2"  y="2"  width="6" height="6" rx="1.5" fill="white" />
      <rect x="10" y="2"  width="6" height="6" rx="1.5" fill="white" opacity="0.6" />
      <rect x="2"  y="10" width="6" height="6" rx="1.5" fill="white" opacity="0.6" />
      <rect x="10" y="10" width="6" height="6" rx="1.5" fill="white" />
    </svg>
  </div>
);

export default HubLogoMark;
